import { createSelector } from 'reselect';

// Config
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';
import { isStripeCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';

const applePayButtonState = createSelector(
  [getSessionIdSelector, isStripeCheckoutEnabledFeatureActive],
  (sessionId, stripeCheckoutFlowEnabled) => ({
    sessionId,
    stripeCheckoutFlowEnabled,
  }),
);

export default applePayButtonState;
